import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { InternalOrganizationMasterServiceAgreementDetailsResponseType } from '../../organization/internal/getInternalOrganizationMasterServiceAgreementDetailsApi';

export type OrganizationMasterServiceAgreementDetailsResponseType =
  InternalOrganizationMasterServiceAgreementDetailsResponseType;

export const getOrganizationMasterServiceAgreementDetailsApi = (
  organizationId: string
): Promise<ApiResponseType<OrganizationMasterServiceAgreementDetailsResponseType>> => {
  const uri = `/opco/organizations/${organizationId}/master-service-agreement/confirmation/`;

  return authApiService.GET(uri);
};
